import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HomeService } from '../../../../services/home.service';
import { Item } from '../../../../interfaces/item';
import { Stockitem } from '../../../../interfaces/stockitem';
import { LanguageServiceService } from '../../../../services/language-service.service';
import { LogoutService } from '../../../Authentication/auth/logout.service';
import { BehaviorSubject } from 'rxjs';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Governorate } from '../../../../interfaces/governorate';
import { GovernoratesService } from '../../../../services/governorates.service';
import { City } from '../../../../interfaces/city';
import { ExcelExportService } from '../../../../services/excel-export.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { PageEvent } from '@angular/material/paginator';
import Swal from 'sweetalert2';
import { UserService } from '../../../../services/user';
import { DeviceDetectorService } from '../../../../services/device-detector.service';
import { PointOfSaleService } from '../../../../services/pos';
import e from 'express';
import { EmployeesService } from '../../../../services/employees';
import { ItemsService } from '../../../../services/items.service';


@Component({
  selector: 'app-allemployees',
  templateUrl: './allemployees.component.html',
  styleUrl: './allemployees.component.scss'
})
export class AllemployeesComponent {

  allData: Stockitem[] = [];
  totalItems = 0;

  isAr: boolean = localStorage.getItem("language") == "ar";
  displayedColumns: string[] = ["name", 'job_title', 'salary', 'address', 'national_id',
    'phone',
    'delete']

  imageURL = '/assets/Home.png';
  isActive = true;
  h5Active = false;
  arabicLag = false;
  classToggled: boolean = false;
  contentReady: boolean = true;
  noData: boolean = false;
  searched: boolean = false;
  searchTerm: any = [];
  filterCards: Item[] = [];
  focusOnSreach: boolean = false;
  AllCategoryactive: boolean = true;
  Medicinsactive: boolean = false;
  Injectionsactive: boolean = false;
  WheelChairsactive: boolean = false;
  isFilterDataOpen: boolean = false;
  FilterDataForm!: FormGroup;
  start_date?: string;
  end_date?: string;
  category_id?: number;
  governorates: Governorate[] = [];
  city_id?: number;
  location?: Governorate;
  cities: City[] = [];
  id?: string;
  quantity?: string;
  itemId?: string;
  stockTotal?: string;
  showRejectPopUp: boolean = false;
  isMobile: boolean = false;
  cartPopUp: boolean = false;
  accountType!: string;
  isAdmin!: boolean;
  isSubAdmin!: boolean;
  searchKey: string = '';
  cartItems: any[] = [];
  cartItemCount: number = 0;
  warehouseId!: any;
  dataSource: MatTableDataSource<any>;
  allWareHouses: any;
  newPage: number = 1;
  openMenuId: number | null = null;


  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private router: Router,
    private _employessService: EmployeesService,
    private _pos: PointOfSaleService,
    private deviceService: DeviceDetectorService,
    private _userService: UserService,
    private _ItemsService: ItemsService,
    private excelExportService: ExcelExportService
  ) {

    this.dataSource = new MatTableDataSource(this.allData);
  }
  toggleMenu(id: number) {
    this.openMenuId = this.openMenuId === id ? null : id;
  }

  closeMenu() {
    this.openMenuId = null;
  }
  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobileDevice();

    this._ItemsService.getWearHouses().subscribe({
      next: (res) => {
        this.allWareHouses = res.warehouse
      },
      error: (err) => {

      },
    });

    this._userService.getAccountType().subscribe({
      next: (data) => {
        this.accountType = data['user_type'];
        this.isAdmin = this.accountType == "1" || this.accountType == "10";
        this.isSubAdmin = this.accountType == "6";
        this.warehouseId = localStorage.getItem("posId");
        if (this.isAdmin) {
          this.getEmployeesByWarehouse(this.warehouseId, 1);
        }
        else {

          if (this.warehouseId != null && this.warehouseId != undefined) {
            this.getEmployeesByWarehouse(this.warehouseId, 1);
          }
          else {
            this.noData = true;
            this.contentReady = false;
          }
        }
      },
      error: (error) => console.error(error),
    });
  }
  getUserwarehouse(id: any, page: any) {
    this.contentReady = true;
    this.searched = false;
    this._pos.getUserPOS(id).subscribe({
      next: (data) => {
        this.allData = data;
        console.log(this.allData);
        this.dataSource = new MatTableDataSource(this.allData);
        if (this.allData.length > 0)
          localStorage.setItem('posId', this.allData[0].id);
        this.contentReady = false;
        if (this.allData.length === 0) {
          this.noData = true;
        } else {
          this.noData = false;
        }
      },
      error: (error) => console.error(error),
    });

  }
  resetPagination() {
    if (this.paginator) this.paginator.firstPage();
    this.newPage = 1;
  }
  applyWareHouse(warehouseId: any) {
    this.resetPagination();
    this.getEmployeesByWarehouse(warehouseId, 1);
  }
  getEmployeesByWarehouse(warehouseId: any, page: any) {
    this.contentReady = true;
    this.searched = false;
    this._employessService.getEmployeesByWarehouse(warehouseId, page, 10).subscribe({
      next: (data) => {
        this.allData = data['data'];
        this.totalItems = data['total'];
        this.dataSource = new MatTableDataSource(this.allData);
        this.contentReady = false;

        if (this.allData.length === 0) {
          this.noData = true;
        } else {
          this.noData = false;
        }
      },
      error: (error) => console.error(error),
    });
  }
  deleteitem(id: string) {
    if (this.isSubAdmin) {
      return;
    }

    Swal.fire({
      title: this.isAr ? "متأكد؟؟" : "Are You Sure?",
      showCancelButton: true,
      confirmButtonText: this.isAr ? "اه" : "YES",
      cancelButtonText: this.isAr ? "لا" : "no"
    }).then((result) => {
      if (result.isConfirmed) {
        this.contentReady = true;
        this._employessService.deleteEmployee(id).subscribe({
          next: (res) => {
            this.contentReady = false;
            this.getEmployeesByWarehouse(this.warehouseId, 1);
          },
          error: (err) => console.log(err),
        });
      }
    });

  }
  getAllEmployees(page: any) {
    this.contentReady = true;
    this.searched = false;
    this._employessService.getAllEmployees(page).subscribe({
      next: (data) => {
        this.allData = data['data'];
        this.stockTotal = data['total'];
        this.totalItems = data['last_page'];
        this.dataSource = new MatTableDataSource(this.allData);
        this.contentReady = false;

        if (this.allData.length === 0) {
          this.noData = true;
        } else {
          this.noData = false;
        }
      },
      error: (error) => console.error(error),
    });
  }
  showEmployee(itemobj: any) {
    this.router.navigate(['/employee'], { queryParams: itemobj });
  }


  onPaginateChange(event: PageEvent) {
    this.newPage = event.pageIndex + 1; // MatPaginator is 0-based

    this.getEmployeesByWarehouse(this.warehouseId, this.newPage);

  }
  edit(itemobj: any) {
    if (this.isSubAdmin) {
      return;
    }

    this.router.navigate(['/addemployee'], { queryParams: itemobj });
  }
  formatDate(date: string): string {
    const d = new Date(date);
    const day = d.getDate().toString().padStart(2, '0');
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const year = d.getFullYear().toString().slice(2); // Getting last two digits of the year
    return `${day}-${month}-${year}`;
  }


}
